import React from 'react';
import { Link } from 'react-router-dom';
import MarketingPageShell from './MarketingPageShell';
import TuningPhilosophyContent from './TuningPhilosophyContent';
import { philosophyIntroPublic, philosophyFaqCategoriesPublic } from '../data/philosophyFaq';
import './MarketingPages.css';

function PhilosophyPage() {
  return (
    <MarketingPageShell>
      <section className="marketing-hero">
        <h1>Tuning philosophy</h1>
        <p className="lede">
          Ideas we use when reading suspension behavior—strokes, balance, compression and rebound—kept at a depth that stays readable on
          the open web. Where thresholds, glossary detail, and symptom maps need to track the live product, we keep that writing beside the
          charts instead of duplicating it here.
        </p>
      </section>

      <div className="marketing-inner">
        <Link to="/" className="marketing-back">
          ← Back to home
        </Link>

        <TuningPhilosophyContent
          variant="marketing"
          intro={philosophyIntroPublic}
          categories={philosophyFaqCategoriesPublic}
        />

        <p
          className="hint"
          style={{
            textAlign: 'center',
            marginTop: '2rem',
            maxWidth: '38rem',
            marginLeft: 'auto',
            marginRight: 'auto',
            lineHeight: 1.65,
          }}
        >
          Already riding with us?{' '}
          <Link to="/login">Sign in</Link> for the long reference and in-app walkthroughs. Still deciding if the hardware is for you?{' '}
          <Link to="/pre-order">Pre-order</Link>
          {' when we are taking names, or '}
          <Link to="/support">reach out</Link>
          {' if a conversation suits you better than a form.'}
        </p>
      </div>
    </MarketingPageShell>
  );
}

export default PhilosophyPage;
